import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Appointment booked", { props: { triggerType: "Appointment Booked", event: "Any calendar" } }],
  ["e1", "auto-email", "Confirmed + what to bring", { props: { subject: "You're booked for {{appointment.date}}" } }],
  ["w1", "auto-wait", "Until 24h before", { props: { duration: "24", unit: "hours" }, notes: "Use a wait-until targeting {{appointment.start}} minus 24h." }],
  ["s1", "auto-sms", "24-hour reminder", { props: { message: "See you tomorrow at {{appointment.time}} — reply R to reschedule" } }],
  ["s2", "auto-sms", "1-hour reminder", { props: { message: "See you in an hour!" } }],
  ["c1", "auto-condition", "No-show?", { props: { condition: "Has tag 'no-show'" } }],
  ["e2", "auto-email", "Reschedule link", { props: { subject: "We missed you — grab a new time" } }],
]);

const def: TemplateDef = {
  slug: "appointment-reminders",
  name: "Appointment No-Show Killer",
  category: "Services",
  tagline:
    "Confirmation, two SMS reminders, and an automatic reschedule email for no-shows.",
  description:
    "A free appointment-reminder template for service businesses: booking page, confirmation email, 24-hour and 1-hour SMS reminders, and a no-show branch that sends a reschedule link automatically. Clone it into FrazzleCRM to run it live.",
  whatsInside: [
    "Booking page wired to an appointment-set trigger",
    "Confirmation email with appointment merge fields",
    "24h + 1h SMS reminders (the no-show killers)",
    "No-show branch that automatically offers a new time",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-google", "Google Ads", 40, 60, { props: { campaign: "Local intent" } }),
      node("src2", "traffic-direct", "Referrals", 40, 220, { props: { source: "Word of mouth" } }),
      node("bk", "page-booking", "Booking page", 360, 140, { props: { duration: "45 min" } }),
      flow("f1", "Reminder Engine", 680, 40, 420, 760),
      ...seq.nodes,
      node("ty", "page-thankyou", "Visit complete", 1200, 340),
      node("n1", "util-note", "The math", 360, 340, {
        notes:
          "SMS reminders routinely cut no-shows 30-50%. Two texts cost pennies; an empty chair costs the whole slot.",
      }),
    ],
    [
      edge("src1", "bk"),
      edge("src2", "bk"),
      edge("bk", "f1"),
      ...seq.edges,
      edge("f1", "ty"),
    ]
  ),
};

export default def;
